import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { Pagination, Button, Modal } from "react-bootstrap";
import { baseURL } from "../../config";

const EmployeeofDepartmentList = () => {
  const [posts, setPosts] = useState({ employeeofdepartment: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [isHR, setIsHR] = useState(false);
  const [isMGR, setIsMGR] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ id: null, status: "" });

  const [isUser, setIsUser] = useState(false);
  const [currdate, setCurrDate] = useState(null);
  const role = localStorage.getItem("userrole");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mypip = searchParams.get("mypip");
  const id = localStorage.getItem("employeeid");
  let paginate = 0;
  let buttonClass = "";
  let rejectBtnClass = "";
  let indexOfLastPost = 0;
  let indexOfFirstPost = 0;
  let currentPosts = null;
  useEffect(() => {
    const fetchPostList = async () => {
      try {
        let url = `${baseURL}/getemployeeofdepartment`;

        const { data } = await axios(url);
        console.log("Fetched data:", data);
        if (Array.isArray(data.employeeofdepartment)) {
          setPosts({ employeeofdepartment: data.employeeofdepartment });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleHRStatus = async (nid, status) => {
    try {
      const response = await axios.get(
        `${baseURL}/hremplyoeedepartment?nid=` +
          nid +
          "&status=" +
          status +
          "&hr=" +
          id
      );
      const data = response.data;
      if (response.status === 200) {
        // alert("Updated award Status to " + status);
        window.location.href = "/employeeofdepartment";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleView = (nominationid) => {
    let currentDate = new Date();
    currentDate = formatDate(currentDate);
    //setCurrDate(currentDate);
    window.location.href = "/employeeofdept?awid=" + nominationid;
    //setSelectedIssue(issue);
  };

  const handleClose = () => {
    setSelectedIssue(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = () => {
    handleHRStatus(modalData.id, modalData.status);
    setShowModal(false);
  };
  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };
  paginate = (pageNumber) => setCurrentPage(pageNumber);

  indexOfLastPost = currentPage * postsPerPage;
  indexOfFirstPost = indexOfLastPost - postsPerPage;

  currentPosts = posts.employeeofdepartment.slice(
    indexOfFirstPost,
    indexOfLastPost
  );
  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">Employee Of the Department</h4>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Employee Name</th>
            <th>Nominator Name</th>
            <th>Award Quarter</th>
            <th>Date Requested</th>
            <th>View Form</th>
            <th>HR. Status</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts != null &&
            currentPosts.map((employee, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>
                  {employee.employee_firstname} {employee.employee_lastname}
                </td>
                <td>
                  {employee.recommended_by_firstname}{" "}
                  {employee.recommended_by_lastname}
                </td>
                <td>{employee.month_year}</td>
                <td>{formatDate(employee.createdat)}</td>
                <td className="d-flex justify-content-center align-items-center">
                  <ReactBootstrap.Button
                    className=" badge bg-secondary  border-0 "
                    onClick={() => handleView(employee.id)}
                  >
                    View
                  </ReactBootstrap.Button>
                </td>
                <td>
                  <div className="d-none">
                    {
                      (buttonClass =
                        employee.hrapproval === "Approved"
                          ? "badge bg-warning ml-1 text-dark border-0" // Different style for approved status
                          : "badge bg-success ml-1 border-0")
                    }
                  </div>
                  <div className="d-none">
                    {
                      (rejectBtnClass =
                        employee.hrapproval === "Rejected"
                          ? "badge bg-danger  ml-1 border-0" // Different style for approved status
                          : "badge bg-danger ml-1 border-0")
                    }
                  </div>

                  <div>
                    <button
                      className={buttonClass}
                      type="button"
                      value="Approve"
                      disabled={employee.hrapproval === "Approved"}
                      onClick={() => {
                        setShowModal(true);
                        setModalData({ id: employee.id, status: "Approved" });
                      }}
                    >
                      {employee.hrapproval === "Approved"
                        ? "Approved"
                        : "Approve"}
                    </button>
                    <button
                      className={rejectBtnClass}
                      type="button"
                      value="Reject"
                      disabled={employee.hrapproval === "Rejected"}
                      onClick={() => {
                        setShowModal(true);
                        setModalData({ id: employee.id, status: "Rejected" });
                      }}
                    >
                      {employee.hrapproval === "Rejected"
                        ? "Rejected"
                        : "Reject"}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </ReactBootstrap.Table>

      <ReactBootstrap.Modal show={selectedIssue !== null} onHide={handleClose}>
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            Employee of the Month Nomination{" "}
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          {selectedIssue && (
            <div>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Justification</th>
                    <th>Recomendation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>{selectedIssue.justification}</td>
                    <td>{selectedIssue.recommendation}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </ReactBootstrap.Modal.Body>

        <ReactBootstrap.Modal.Footer>
          <ReactBootstrap.Button variant="secondary" onClick={handleClose}>
            Close
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>
      <ReactBootstrap.Pagination>
        {Array.from(
          {
            length: Math.ceil(posts.employeeofdepartment.length / postsPerPage),
          },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to confirm the changes?</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirmSubmit}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EmployeeofDepartmentList;
